/** GA4 web stream measurement ID (`G-XXXXXXXX`). Empty disables client analytics. */
export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim() ?? '';

/** When true, events are sent only after the user grants analytics consent. */
export const GA_REQUIRE_CONSENT =
  process.env.NEXT_PUBLIC_GA_REQUIRE_CONSENT === 'true';

export const GA_CONSENT_STORAGE_KEY = 'ffl-analytics-consent';

export const GA_SHELTER_CONTEXT_STORAGE_KEY = 'ffl-analytics-shelter-id';

/** Routes excluded from automatic GA page views (admin console). */
export const GA_EXCLUDED_PATH_PREFIXES = ['/admin'] as const;

export const GA4_CUSTOM_DIMENSIONS = [
  'shelter_id',
  'species',
  'animal_id',
  'dimension_key',
  'surface',
  'match_count',
] as const;
